import { useRef, useState, useLayoutEffect } from 'react';

import { Button } from '@vimeo/bokeh';
import { CheckSmall, CloseXSmall } from '@vimeo/bokeh-icons';
import { User } from '@vimeo/gctl-api/models/components/schemas/user/User';
import { translate } from '@vimeo/i18n-runtime';
import { useFollowUser } from '@vimeo/use-follow';

export function FollowButton({ user, source }: { user: User; source: string }) {
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const { updateFollow, isFollowingSubject } = useFollowUser(user, {
    source,
  });
  const [btnHover, setBtnHover] = useState(false);

  // We have to creatively manage hover state for the button
  // Because some aspect of the PopOver is hijacking the hover events.
  // Chakra's _groupHover is not functioning as expected
  useLayoutEffect(() => {
    const btn = btnRef.current;
    if (!btn) {
      return;
    }
    btn.addEventListener('mouseover', () => setBtnHover(true));
    btn.addEventListener('mouseout', () => setBtnHover(false));
    return () => {
      btn.removeEventListener('mouseover', () => setBtnHover(true));
      btn.removeEventListener('mouseout', () => setBtnHover(false));
    };
  }, [btnRef]);

  return (
    <Button
      ref={btnRef}
      size="sm"
      w="100%"
      onClick={(e) => {
        e.preventDefault();
        updateFollow();
      }}
      variant="secondary"
    >
      {isFollowingSubject ? (
        btnHover ? (
          <>
            <CloseXSmall />
            {translate('Unfollow')}
          </>
        ) : (
          <>
            <CheckSmall />
            {translate('Following')}
          </>
        )
      ) : (
        <>{translate('Follow')}</>
      )}
    </Button>
  );
}
